import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import Loading, { LoadingBall } from '@ingka/loading';
import { selectCurrencyCode } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { translate } from '@repo/phrase';
import { Paragraph } from '@repo/ui/typography';

import { AssetActionButtons } from '@/components/asset-details/asset-action-buttons/asset-action-buttons.component';
import { AssetPriceSummaryModal } from '@/components/asset-details/asset-price-summary-modal/asset-price-summary-modal.component';
import { MODAL } from '@/components/modals/asset-modal.types';

import { useAssetPriceTotals } from '@/hooks/asset-price-totals.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { formatPrice } from '@/utils/translation.utils';
import { getAppConfig } from '@/utils/window.utils';

import { AssetPriceSummaryLink } from './asset-price-summary-link/asset-price-summary-link.component';

import styles from '../styles.module.scss';

export const AssetPriceSummaryBox = () => {
    const { assetType, assetId } = useAssetParams();
    const { data, isLoading } = useAsset(assetType, assetId);
    const config = getAppConfig();
    const showPriceSummary = config.feature.showPriceSummary?.enable;
    const { totalOrderValue } = useAssetPriceTotals();
    const currencyCode = selectCurrencyCode(data);
    const activeModal = useAssetActionModalStore((state) => state.activeModal);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);

    if (isLoading) {
        return (
            <Loading text={translate('text.loading')}>
                <LoadingBall color="primary" />
            </Loading>
        );
    }

    return (
        <>
            <div className={styles.asset_details_total}>
                <div className={styles.asset_details_total_price}>
                    <Paragraph className={styles.asset_details_total_text ?? ''}>
                        {translate('order_sidebar_total')}
                    </Paragraph>
                    <Paragraph className={styles.asset_details_total_text ?? ''}>
                        {formatPrice(totalOrderValue, currencyCode)}
                    </Paragraph>
                </div>

                <hr className={styles.divider} />

                {showPriceSummary && <AssetPriceSummaryLink />}

                <hr className={styles.divider_bottom} />

                <AssetActionButtons />
            </div>

            {showPriceSummary && (
                <AssetPriceSummaryModal
                    onClose={() => {
                        setActiveModal(null);
                    }}
                    visible={activeModal === MODAL.PRICE_SUMMARY}
                />
            )}
        </>
    );
};
